import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { formatFullDate } from '../../utils/dateUtils';
import { EventStateModel } from '../../types/eventModels';

const initialEventState: EventStateModel = {
  allEvents: [],
  nextIndex: '',
  loaded: false,
  numOfRecords: -1,
  searchInputValue: undefined,
};

const eventSlice = createSlice({
  name: 'event',
  initialState: initialEventState,
  reducers: {
    setEvents(state, action: PayloadAction<{ data: any; searchInput: any; countToGet: any }>) {
      state.allEvents = [...action.payload.data.events.slice(0, action.payload.countToGet)];
      // state.allEvents = [...action.payload.data.events];
      state.nextIndex = action.payload.data.nextIndex;
      state.loaded = true;
      state.numOfRecords = action.payload.data.events.length;
      state.searchInputValue = action.payload.searchInput;
      if (state.allEvents && state.allEvents.length > 0) {
        state.allEvents.map(event => {
          event.displayDate = formatFullDate(event.eventDate.start);
          event.date = new Date(event.eventDate.start);

          return event;
        });
      }
      state.allEvents = state.allEvents.sort(
        (first: any, second: any) => 0 - (new Date(first.date).getTime() < new Date(second.date).getTime() ? -1 : 1),
      );
    },
    appendEvents(state, action: PayloadAction<any>) {
      state.allEvents = [...state.allEvents, ...action.payload.data.events];
      state.nextIndex = action.payload.data.nextIndex;
      state.loaded = true;
      state.numOfRecords = action.payload.data.events.length;
      state.searchInputValue = action.payload.searchInput;
      if (state.allEvents && state.allEvents.length > 0) {
        state.allEvents.map(event => {
          event.displayDate = formatFullDate(event.eventDate.start);
          event.date = new Date(event.eventDate.start);

          return event;
        });
      }
      state.allEvents = state.allEvents.sort(
        (first: any, second: any) => 0 - (new Date(first.date).getTime() < new Date(second.date).getTime() ? -1 : 1),
      );
    },
    clearEvents(state) {
      state.allEvents = [];
      state.nextIndex = '';
      state.numOfRecords = -1;
    },
  },
});

export default eventSlice;
